__turbopack_context__.v({
  "flex-wrap": "styles-module__Snw91a__flex-wrap",
});
